import { render, staticRenderFns } from "./label-card.vue?vue&type=template&id=4ed0d5bb&"
import script from "./label-card.vue?vue&type=script&lang=js&"
export * from "./label-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports